"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _graphql = require("./graphql");
Object.keys(_graphql).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _graphql[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _graphql[key];
        }
    });
});
var _operations = require("./operations");
Object.keys(_operations).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _operations[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _operations[key];
        }
    });
});
